import React from 'react';
import { Link } from 'gatsby';
import { HTMLContent } from './Content';

export function BlogPostPreview({ title, content, href }) {
  return (
    <div>
      <Link to={href}>
        <h2 className="title is-2">{title}</h2>
      </Link>
      <HTMLContent style={{ padding: '1rem 0' }} content={content} />
      <Link to={href}>Читать дальше →</Link>
    </div>
  );
}
